import { useState } from 'react';
import { FlexSpacer } from 'ui/flexSpacer';
import { DestructiveButton } from 'ui/button';
import { Tooltip } from 'ui/tooltip';
import { Toggle, TOGGLE_SIZES } from 'ui/toggle';
import { toggleDashboardMock, useMock } from 'api/DashboardAPI';
import { dashboardData, dashboardDataReset } from 'api/mock/DashboardMockData';

type MockSettingsProps = {
  onSetDashboard: (data: typeof dashboardData | typeof dashboardDataReset) => void;
};

export const MockSettings = ({ onSetDashboard }: MockSettingsProps) => {
  const [isMockedEnabled, setIsMockEnabled] = useState(useMock());

  const handleToggleDashboardMock = () => {
    toggleDashboardMock();
    setIsMockEnabled(!isMockedEnabled);
  };

  return (
    <FlexSpacer
      data-test={`mock-settings${isMockedEnabled ? '-mock' : ''}`}
      justifyContent="space-between"
    >
      Enable dashboard mock
      <Toggle
        data-test="mock-settings-toggle"
        size={TOGGLE_SIZES.LARGE}
        isActive={isMockedEnabled}
        onClick={handleToggleDashboardMock}
      />
      <FlexSpacer>
        <Tooltip
          isEnabled={isMockedEnabled}
          tooltipContent="Warning: This will erase the entire dashboard."
        >
          <DestructiveButton
            isDisabled={!isMockedEnabled}
            onClick={() => onSetDashboard(dashboardDataReset)}
          >
            Clear Dashboard
          </DestructiveButton>
        </Tooltip>
        <Tooltip
          isEnabled={isMockedEnabled}
          tooltipContent="Warning: Generates a new dashboard which will replace current dashboard. You may need to
        refresh page after clicking button."
        >
          <DestructiveButton
            isDisabled={!isMockedEnabled}
            onClick={() => onSetDashboard(dashboardData)}
          >
            Generate New Dashboard
          </DestructiveButton>
        </Tooltip>
      </FlexSpacer>
    </FlexSpacer>
  );
};
